var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxoneicons6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#005c74;}.cls-2{fill:#01cab8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1 copy 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.28,52.73h-46a8.71,8.71,0,0,0-8.72,8.72V203.27a8.71,8.71,0,0,0,8.72,8.72h46a8.71,8.71,0,0,0,8.72-8.72V61.45A8.71,8.71,0,0,0,244.28,52.73Zm-8.72,141.83H207V70.17h28.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.4,6.23h-46A8.71,8.71,0,0,0,113.69,15V203.27A8.71,8.71,0,0,0,122.4,212h46a8.71,8.71,0,0,0,8.71-8.72V15A8.72,8.72,0,0,0,168.4,6.23Zm-8.72,188.33H131.12V23.67h28.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.51,76h-46A8.71,8.71,0,0,0,37.8,84.7V203.27A8.71,8.71,0,0,0,46.52,212h46a8.71,8.71,0,0,0,8.72-8.72V84.7A8.71,8.71,0,0,0,92.51,76ZM83.79,194.56H55.24V93.42H83.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.28,232.33H20.44V15A8.72,8.72,0,0,0,3,15v226.1a8.71,8.71,0,0,0,8.72,8.72H244.28a8.72,8.72,0,0,0,0-17.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxoneicons6);
export default __webpack_public_path__ + "static/media/rx one icons (6).de2d4323a223af156a1068f433d69ef9.svg";
export { ForwardRef as ReactComponent };